import React from "react";
import styled, { css } from "styled-components";
import flags from "../../data/flags.json";

const Contributor = ({ 
    mode, 
    profile,
    displayFlag
}) => {
    const { languages, rank, contributions, avatarUrl, login, url, country } = profile;
    const iso = flags[country];

    return <ProfileWrapper mode={ mode }>
        <Flag className="country" isFlagDisplayed={ displayFlag }>
            <img 
                src={ require(`../../assets/flags/${ iso }.png`)}
                alt={ `${ country } flag`} />  
        </Flag>
        <div style={{ display: "flex" }}>
            <Avatar src={ avatarUrl } alt={ login } />
            <div style={{ marginLeft: "16px" }}>
                <p>rank <span style={{ fontWeight: "bold", fontSize: "16px" }}>{ rank } { rank === 1 ? "🥇" : rank === 2 ? "🥈" : rank === 3 ? "🥉" : null } </span></p>
                <a href={ url } target="_blank" style={{ color: "inherit", fontSize: "24px" }}><p>{ login }</p></a>
                <p>contributions <span style={{ fontWeight: "bold", fontSize: "14px" }}>{contributions}</span></p>
            </div>
        </div>
        <TopUsedLanguages>
            { languages[0] ? <LangMeta mode={ mode }>1. { Object.keys(languages[0])[0] } </LangMeta> : null } 
            { languages[1] ? <LangMeta mode={ mode }>2. { Object.keys(languages[1])[0] } </LangMeta> : null } 
            { languages[2] ? <LangMeta mode={ mode }>3. { Object.keys(languages[2])[0] } </LangMeta> : null } 
        </TopUsedLanguages>
    </ProfileWrapper>
}


const ProfileWrapper = styled.div`
    padding: 16px 0;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #e2e2e2;
    padding: 12px;
    border-radius: 3px;
    margin-bottom: 12px;
    position: relative;

    ${ props => props.mode === "dark" && css`
        background: #353535;
    ` }
`

const Flag = styled.div`
    position: absolute;
    top: 0;
    right: 5px;

    ${ props => !props.isFlagDisplayed && css`
        display: none;
    ` }
`

const LangMeta = styled.div`
    font-size: 10px;
    background: #d0d0d0;
    padding: 3px 12px;
    border-radius: 5px;
    font-weight: bold;

    ${ props => props.mode === "dark" && css`
        background: #5d5d5d;
    ` }
`

const Avatar = styled.img`
    width: 81px;
    height: 81px;
    min-width: 81px;
    min-height: 81px;
    border-radius: 5px;
`

const TopUsedLanguages = styled.div`
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: center;
    width: 100%;
    margin-top: 16px;
    justify-content: space-between;
`

export default Contributor;